import { LocaleId, TranslationDictionaryMapping } from '@domgen/dgx-fe-i18n';
import { RegistrationTermsAndConditionsTranslationDictionary } from './registration-terms-and-conditions-dictionary.interface';

export const translation: TranslationDictionaryMapping<RegistrationTermsAndConditionsTranslationDictionary> =
  {
    [LocaleId.English_GreatBritain]: {
      SHARED_UI_TERMS_AND_CONDITIONS:
        'See the full inclusions and exclusions in the {{ termsAndConditions }}. Also check the policy summary in the {{ ipid }}',
    },
    [LocaleId.English_Ireland]: {
      SHARED_UI_TERMS_AND_CONDITIONS:
        'All repairs and replacements are subject to approval inline with the {{ ipid }} {{ conjunction }} {{ termsAndConditions }}. The main exclusions are: cosmetic and malicious damage, costs that you may incur due to your product being unusable, and installation and disposal charges for a replacement product.',
    },
    [LocaleId.English_US]: {
      SHARED_UI_TERMS_AND_CONDITIONS:
        'All repairs and replacements are subject to approval inline with the {{ termsAndConditions }}.',
    },
  };
